import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Information")
], -1)
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "pt-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex items-center pt-0" }
const _hoisted_6 = { class: "pt-0" }
const _hoisted_7 = { class: "pt-0" }
const _hoisted_8 = { class: "pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_SelectCatalogCategory = _resolveComponent("SelectCatalogCategory")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_SelectCatalogTags = _resolveComponent("SelectCatalogTags")!
  const _component_SelectCatalogPublishStatus = _resolveComponent("SelectCatalogPublishStatus")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_RefreshLeft = _resolveComponent("RefreshLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.props.catalog,
          rules: _ctx.rules,
          "label-width": "15%",
          class: "font-bold"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              class: "font-bold",
              prop: "name",
              label: "Name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.props.catalog.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.props.catalog.name) = $event)),
                  placeholder: "Enter name"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "font-bold",
              prop: "productCode",
              label: "Code"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.props.catalog.productCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.props.catalog.productCode) = $event)),
                    placeholder: "Code"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "font-bold",
              prop: "category",
              label: "Category"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectCatalogCategory, {
                  modelValue: _ctx.props.catalog.categories,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.props.catalog.categories) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_el_form_item, {
                    class: "font-bold",
                    prop: "niches",
                    label: "Niches"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.props.catalog.niches,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.props.catalog.niches) = $event)),
                        multiple: "",
                        class: "w-full",
                        filterable: "",
                        "allow-create": "",
                        "default-first-option": "",
                        "reserve-keyword": false,
                        placeholder: "Enter niches"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalog.niches, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "font-bold",
                    prop: "category",
                    label: "Tag"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectCatalogTags, {
                        modelValue: _ctx.props.catalog.tags,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.props.catalog.tags) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "publishStatus",
                    label: "Publish status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectCatalogPublishStatus, {
                        modelValue: _ctx.props.catalog.publishStatus,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.props.catalog.publishStatus) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "font-bold",
                    prop: "outOfStock",
                    label: "Stock status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.props.catalog.outOfStock,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.props.catalog.outOfStock) = $event)),
                        placeholder: "Stock"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            key: 0,
                            label: "In stock",
                            value: false
                          }),
                          _createVNode(_component_el_option, {
                            key: 1,
                            label: "Out of stock",
                            value: true
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              class: "font-bold",
              prop: "",
              label: "Display price ($)"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.props.catalog.displayPrice,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.props.catalog.displayPrice) = $event)),
                    placeholder: "Display price",
                    controls: false
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    type: "text",
                    class: "mx-3",
                    title: "Get min price",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (
                _ctx.props.catalog.displayPrice = _ctx.props.catalog?.variants
                  ? Math.min(
                      ..._ctx.props.catalog.variants.map(
                        variant => variant?.cost || 0
                      )
                    )
                  : 0
              ))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_RefreshLeft)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "font-bold",
              prop: "",
              label: "Catalog type"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_select, {
                    clearable: "",
                    modelValue: _ctx.props.catalog.type,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.props.catalog.type) = $event)),
                    placeholder: "Type"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                  { label: 'POD', value: 'pod' },
                  { label: 'DROP', value: 'drop' },
                  { label: 'FK', value: 'fake' },
                ], (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          placeholder: "Type",
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "font-bold",
              prop: "designAndTemplateUrl",
              label: "Mockup & Template"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.props.catalog.designAndTemplateUrl,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.props.catalog.designAndTemplateUrl) = $event)),
                    placeholder: "Mockup & Template URL"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "font-bold",
              prop: "status",
              label: "Status"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.props.catalog.status,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.props.catalog.status) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tabs, {
              modelValue: _ctx.activeName,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.activeName) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "OVERVIEW",
                  name: "description",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { class: "font-bold" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Editor, {
                          modelValue: _ctx.props.catalog.description,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.props.catalog.description) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "FEATURE",
                  name: "description2",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { class: "font-bold" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Editor, {
                          modelValue: _ctx.props.catalog.description2,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.props.catalog.description2) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "SIZE GUIDE",
                  name: "sizeGuide",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { class: "font-bold" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_Editor, {
                            modelValue: _ctx.props.catalog.sizeGuide,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.props.catalog.sizeGuide) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "FULFILLMENT PRICE",
                  name: "shippingDetail",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { class: "font-bold" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Editor, {
                          modelValue: _ctx.props.catalog.shippingDetail,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.props.catalog.shippingDetail) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "PRINT FILES GUIDE",
                  name: "printGuide",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { class: "font-bold" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Editor, {
                          modelValue: _ctx.props.catalog.printGuide,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.props.catalog.printGuide) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "CARE INSTRUCTIONS",
                  name: "service",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { class: "font-bold" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Editor, {
                          modelValue: _ctx.props.catalog.service,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.props.catalog.service) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 1
  }))
}